import { Calendar, CalendarMonths, Tabs } from '@/molecules';

import { isDayBlocked, isDayHighlighted } from '@/utils';

import type { FunctionComponent } from 'react';
import type { TypeAvailableDatesProps } from './types';

/**
 * AvailableDates
 */
export const AvailableDates: FunctionComponent<TypeAvailableDatesProps> = ({
  className = '',
  availableDates,
}: TypeAvailableDatesProps) => (
  <div id="available-dates" className={`flex flex-col pt-6 pb-8 ${className}`}>
    <div className="mb-4 flex flex-col gap-2">
      <p className="text-headline text-headline--h4 text-text-neutrals-900">
        Disponibilidad del alojamiento
      </p>

      <p className="text-body text-body--m text-text-neutrals-900">
        La estancia máxima es de 11 meses y la mínima de 1 mes
      </p>
    </div>

    <Tabs
      tabs={['Vista diaria', 'Vista mensual']}
      classNameTabs="md:w-[324px] ml-0 w-full"
      unmount
    >
      <>
        <Calendar
          numberOfMonths={2}
          type="range"
          variant="availability"
          className="flex flex-col justify-center p-px max-xl:hidden"
          isDayHighlighted={(day) => isDayHighlighted(day, availableDates)}
          isDayBlocked={(day) => isDayBlocked(day, availableDates)}
        />

        <Calendar
          numberOfMonths={1}
          type="range"
          variant="availability"
          className="mx-auto flex flex-col justify-center p-px xl:hidden max-md:[&_div:nth-child(1)]:self-center"
          isDayHighlighted={(day) => isDayHighlighted(day, availableDates)}
          isDayBlocked={(day) => isDayBlocked(day, availableDates)}
        />
      </>

      <CalendarMonths availableDates={availableDates} />
    </Tabs>
  </div>
);

AvailableDates.displayName = 'AvailableDates';
